/*@flow*/
import type { Element } from 'react';
import React from 'react';
import cx from 'classnames';
import isString from 'lib/t/isString';
import type { PathT } from '../types';

function getClassName(locals) {
  const len = locals.path.length;
  let className = `fieldset fieldset-depth-${len}`;
  if (len > 0) {
    className += ` fieldset-${locals.path.join('-')}`;
  }
  const c = locals.className;
  if (c) {
    className += ` ${cx(c)}`;
  }

  return className;
}

function Legend(locals) {
  const { hasError, label } = locals;
  return label ? (
    isString(label) ? (
      hasError ? (
        <legend className={cx({ 'text-danger font-weight-bold': hasError })}>
          {label}
        </legend>
      ) : (
        <legend>{label}</legend>
      )
    ) : (
      label
    )
  ) : null;
}

type PropsT = {
  children: React$Node,
  path: PathT,
  label: React$Node,
  className: string,
  disabled?: boolean,
  hasError: boolean,
};

export default (props: PropsT): Element<'fieldset'> => {
  const { children, ...locals } = props;
  const { disabled } = locals;

  const props2 = {
    className: getClassName(locals),
    disabled,
  };

  return (
    <fieldset {...props2}>
      <Legend {...locals} />
      {children}
    </fieldset>
  );
};
